import styled from 'styled-components';

export const StyledInput = styled.input(
  ({
    helperText,
    fullWidth,
    error,
    disabled,
    theme: { colors, font, spacing, border },
  }) => ({
    '&[type=datetime-local]': {
      '-webkit-appearance': 'none',
    },
    '-webkit-appearance': 'none',
    ':active, :hover': {
      borderColor: error ? colors.error : colors.darkGrey,
    },
    ':disabled': {
      background: colors.backgroundGrey,
      color: colors.darkGrey,
    },
    ':focus': {
      borderColor: error ? colors.error : colors.primary,
      color: error ? colors.error : colors.black,
    },
    ':hover:disabled, :active:disabled': {
      border: `1px solid ${colors.disabled}`,
    },
    ':placeholder': {
      color: colors.darkGrey,
    },
    background: colors.white,
    border: `1px solid ${error && !disabled ? colors.error : colors.disabled}`,
    borderRadius: border.radius.sm,
    boxShadow: 'none',
    color: error ? colors.error : colors.black,
    display: 'block',
    fontSize: font.size.md,
    lineHeight: font.lineHeight.md,
    marginBottom: helperText ? spacing.sm : spacing.md,
    outline: 'none',
    padding: spacing.sm,
    width: fullWidth ? '100%' : 'auto',
  }),
);

export const InputContainer = styled.div(
  ({ helperText, fullWidth, theme: { spacing } }) => ({
    marginBottom: helperText ? spacing.sm : spacing.md,
    position: 'relative',
    svg: {
      left: spacing.sm,
      marginTop: '-12px',
      position: 'absolute',
      top: '50%',
    },
    width: fullWidth ? '100%' : 'auto',
  }),
);

export const StyledInputWithIcon = styled(StyledInput)(() => ({
  marginBottom: 0,
  paddingLeft: '40px',
}));

export const StyledHelperText = styled.small(
  ({ error, theme: { spacing, font, colors } }) => ({
    color: error ? colors.error : colors.darkGrey,
    display: 'block',
    fontSize: font.size.xs,
    fontWeight: font.weight.normal,
    lineHeight: font.lineHeight.xs,
    paddingBottom: spacing.md,
    width: '100%',
  }),
);
